module.exports = __webpack_public_path__ + "static/img/fish26.0daeb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish26.png
// module id = S5s/
// module chunks = 0